import { Injectable } from "@angular/core";
import { Subject, BehaviorSubject } from "rxjs";

@Injectable({ providedIn: 'root' })
export class QuickSearchService {
  constructor() {}
  
  private _guickSearchReset = new Subject<void>();
  private _guickSearchValue = new BehaviorSubject<string>('');
  public readonly guickSearchReset$ = this._guickSearchReset.asObservable();
  public readonly guickSearchValue$ = this._guickSearchValue.asObservable();

  resetQuickSearch() {
    this._guickSearchReset.next();
  }

  setSearchValue(value: string) {
    this._guickSearchValue.next(value);
  }
}
